import { MutationFunctionOptions } from '@apollo/client';
import { ActivateBlendLoanMutation, Exact } from 'src/services/graphql/generated/graphql';

export const createActiveBlendLoanPayload = (
    id: string
): MutationFunctionOptions<
    ActivateBlendLoanMutation,
    Exact<{
        loanId: string;
    }>
> => ({
    variables: {
        loanId: id,
    },
});
